export default __webpack_public_path__ + "static/media/furniture3.78d91f4b.jpeg";